$(function () {
    var haendlersuche = L.map('haendlersuche', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([51.1642292, 10.4541194], 6);
    var own_location = false;

    L.tileLayer('/tiles/{x}/{y}/{z}', {
    //L.tileLayer('https://map.nextcontrol.de/tile/{z}/{x}/{y}.png', {
        attribution: '',
    }).addTo(haendlersuche);

    var markers = L.markerClusterGroup({
        showCoverageOnHover: false,
    });

    var addMarkers = function (results) {
        var m = null;
        var result_list = true;
        if (results.length === 0 && $('.search-container input').val() == '') {
            m = merchants;
            result_list = false;
        } else {
            /*id_list = results.map(function (id) {
                return id.id
            })
            m = merchants.filter(function(merchant) {
                var distance = results.filter(function (id) {
                    return id.id == merchant.id
                })
                if (id_list.includes(merchant.id)) {
                    merchant.distance = distance[0].distance.toFixed(1)
                }
                return id_list.includes(merchant.id);
            });*/
            m = results
        }
        /*if (result_list) $('.location-filter').removeClass('d-none')
        else $('.location-filter').addClass('d-none')*/
        $('.location-filter .count').html(m.length);
        $('.location-filter .radius-value').html($('.location-filter .radius select').val());
        var i = 0;
        m.forEach(function(merchant) {
            i++;
            markers.addLayer(L.marker([merchant.latitude, merchant.longitude], {
                title: merchant.name,
                icon: L.icon({
                    iconSize: [28, 27],
                    popupAnchor: [8, -27],
                    iconAnchor: [5, 27],
                    iconUrl: '/images/haberland_flag2.png'
                }),
            }).bindPopup('<strong>' + merchant.name + '</strong>' + (merchant.owner ? '<br>' + merchant.owner : '') + '<br>' + merchant.street + '<br>' + merchant.zip + ' ' + merchant.city + (merchant.phone ? '<br>' + merchant.phone : '') + (merchant.email ? '<br><a href="mailto:' + merchant.email + '">' + merchant.email + '</a>' : '')));
            if (result_list) {
                $('.location-filter .results').append($('<div class="card mb-3">')
                    .append($('<div class="card-body">')
                        .append($('<div class="d-flex" style="justify-content: space-between;">')
                            .append($('<h6 style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">').text(merchant.name))
                            .append($('<small class="d-flex" style="justify-content: flex-end; white-space: nowrap;">').text(merchant.distance + ' km')))
                        .append($('<h7 class="card-subtitle mb-2 text-muted">').text(merchant.owner))
                        .append($('<p class="card-text">').html(merchant.street + '<br>' + merchant.zip + ' ' + merchant.city))))   //.text(merchant.name + ' | ' + (merchant.distance) + ' km'))
            }
        });
        if (i === 0) {
            i = 1;
        }
        return i;
    };
    haendlersuche.addLayer(markers);

    addMarkers([]);

    var $zip = $('.haendlersuche-wrapper input');
    var $search = $('.haendlersuche-wrapper button');

    var search = function (results, possible_zip) {
        markers.clearLayers();
        $('.location-filter .results').html('');
        if (possible_zip) {
            $('.location-filter .radius').addClass('d-none')
            $('.location-filter .radius-value').addClass('d-none')
        } else {
            $('.location-filter .radius').removeClass('d-none')
            $('.location-filter .radius-value').removeClass('d-none')
        }
        var i = addMarkers(results);
        if (results.length) {
            markers.refreshClusters();
            haendlersuche.fitBounds(markers.getBounds(), {
                padding: [50, 50]
            })
            return 1;
        } else {
            $('.location-filter .results').append($('<div class="card mb-3">')
                .append($('<div class="card-body">')
                    .append($('<p class="m-0 text-center">').text('Keine Treffer gefunden!'))))
        }
    }

    if (!navigator.geolocation) {
        $('.navigator').addClass('d-none')
    } else {
        $('.navigator button').click(function () {
            navigator.geolocation.getCurrentPosition(function (position) {
                $('.navigator').addClass('d-none')
                own_location = position;
                run_search()
                /*$.post('/haendlersuche/locate', {lat: position.coords.latitude, lng: position.coords.longitude, radius: $('.radius select').val()}, function (result) {
                    $('.search-container input').val(result.search)
                    search(result.results)
                })*/
            }, function () {
                console.log('failed')
            });
        })
    }
    $('.search-container input').keyup(function (e) {
        if (e.which == 13) {
            $('.navigator').removeClass('d-none')
            own_location = false;
            run_search()
            /*$.post('/haendlersuche/locate', {query: $(this).val(), radius: $('.radius select').val()}, function (result) {
                console.log(result)
                search(result.results)
            })*/
        }
    })
    $('.location-filter .radius select').change(function () {
        run_search()
    })
    var run_search = function() {
        if (own_location === false) {
            $.post('/haendlersuche/locate', {query: $('.search-container input').val(), radius: $('.radius select').val()}, function (result) {
                search(result.results, result.possible_zip)
            })
        } else {
            $.post('/haendlersuche/locate', {lat: own_location.coords.latitude, lng: own_location.coords.longitude, radius: $('.radius select').val()}, function (result) {
                $('.search-container input').val(result.search)
                search(result.results, result.possible_zip)
            })
        }
    }

    $search.click(search);
    $zip.keyup(function (e) {
        if (e.keyCode == 13) {
            search([]);
        }
    });
});
